module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Iain Levison\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Iain Levison is the author of "), _c('I', [_vm._v("A Working Stiff’s Manifesto")]), _vm._v(", an account of his post-collegiate work experience, consisting of forty-two jobs in ten years, and of two previous novels, "), _c('I', [_vm._v("Since the Layoffs")]), _vm._v(" and "), _c('I', [_vm._v("Dog Eats Dog")]), _vm._v(". He lives in Raleigh, North Carolina.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Eky9My/tc-custom/9781569477113.jpg?1726483161129",
      "alt": "This image is the cover for the book How to Rob an Armored Car"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("How to Rob an Armored Car\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A comical crime caper about three stoners with a plan: “By turns funny, sad, and insightful” ("), _c('i', [_vm._v("Booklist")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In a dying Pennsylvania coal town, three friends are looking for a way out. Mitch is a rebellious malcontent whose bad attitude gets him fired from a chain big box store. Doug can identify any pill by sight and any eighties rock song by the first three notes, but doesn’t understand credit scores. Kevin got married and had a kid too soon and is now on parole after serving jail time for growing marijuana."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The three of them dabble in petty crime and believe they have a talent for it. They start by stealing a high-definition TV. Then they set their sights on bigger scores. But things are about to get out of hand . . ."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “An honest and humorous romp through lower middle-class frustration.” —"), _c('i', [_vm._v("Publishers Weekly")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Soho Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0